import { render, staticRenderFns } from "./LicenseWarning.vue?vue&type=template&id=714e2cb7&scoped=true"
import script from "./LicenseWarning.vue?vue&type=script&lang=ts"
export * from "./LicenseWarning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714e2cb7",
  null
  
)

export default component.exports